import O1HD from "../../../../engines/gameEngine";
import ChickenPurchaseNode from "./ChickenPurchaseNode";
import NormalGameManager from "../../manager/NormalGameManager";
import ChickenItemPrefab from "./ChickenItemPrefab";
import {ChickenCacheEntity, NormalBackpackI} from "../../manager/DefineInterface";
import {getChickEntityById} from "./config/ChickConfig";
import ChickenEnlargeCapacity from "./ChickenEnlargeCapacity";
import gameConfig from "../../../../engines/configs/gameConfig";

const {ccclass, property} = cc._decorator;

/**
 * 鸡 园
 */
@ccclass
export default class ChickenPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"鸡活动背景节点"})
    bgNode : cc.Node = null;

    @property({type:cc.Node,displayName:"活动Node"})
    activityNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"鸡Item 预制体"})
    chickenItemPrefab : cc.Node = null;

    @property({type:cc.Prefab,displayName:"购买预制体"})
    purchasePrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"图鉴预制体"})
    drawingGuidePrefab : cc.Prefab = null;
    @property(cc.Node)
    blackHoleNode : cc.Node = null;
    @property(cc.Node)
    uiNode : cc.Node = null;

    onLoad () {
        O1HD.on("ChickenPrefab.checkHoleNode" , this.checkHoleNode , this );
        O1HD.on("ChickenPrefab.recycleHoleMoney" , this.recycleHoleMoney , this );
        O1HD.on("ChickenPrefab.addChickItemNode",this.addChickItemNode , this );
    }

    start () {
        this.bgNode.zIndex = -10000;
        if ( !NormalGameManager._instance.getGameData().chickenCoop.nestData ) {
            NormalGameManager._instance.getGameData().chickenCoop.nestData = [];
        }
        if ( !NormalGameManager._instance.getGameData().batchingBinData ) {
            NormalGameManager._instance.getGameData().batchingBinData = [];
        }
        this.loadData();
        O1HD.getManagers().soundMgr.playMusic("hallBgm");

        //TODO 测试 添加特定蛋
        // NormalGameManager._instance.onPushGoods( 10378 , 1 );
        // //
        // NormalGameManager._instance.onPushGoods( 10383 , 1 );
        // NormalGameManager._instance.onPushGoods( 10384 , 1 );
        // NormalGameManager._instance.onPushGoods( 10385 , 1 );
        // NormalGameManager._instance.onPushGoods( 10386 , 1 );
        // NormalGameManager._instance.onPushGoods( 10391 , 1 );

    }

    loadData(){
        //开始离线收益
        this.offLineData();
        // 加载鸡的缓存
        let chickenData = NormalGameManager._instance.getGameData().chickenData;
        for ( let chickenCacheData of chickenData ) {
            // console.log(`添加`,chickenCacheData );
            this.addChickItemNode( chickenCacheData );
        }
    }

    /**
     * 离线数据
     */
    offLineData(){
        //判断 鸡下不下蛋，下几个蛋,蛋的仓储数量需要在配置表里面进行控制
        let chickenData = NormalGameManager._instance.getGameData().chickenData;
        for ( let chickenCacheData of chickenData  ) {
            this._offLineCheckChicken( chickenCacheData );
        }

        NormalGameManager._instance.writeGameData();
    }
    _offLineCheckChicken( chickenCacheEntity : ChickenCacheEntity ){
        let chickEntity = getChickEntityById( chickenCacheEntity.chickenId);
        // 判断是否 变大
        if ( chickEntity.becomeBigId ) {
            let hour = NormalGameManager._instance.mGameHours - chickenCacheEntity.bornGameHour;
            let minute = NormalGameManager._instance.mMinute - chickenCacheEntity.bornGameMinute;
            let hasLiveSeconds = hour * ( 60 / gameConfig.CHICKEN_SECONDS_RATE) + Math.floor( minute / gameConfig.CHICKEN_SECONDS_RATE ) * 1;
            if ( hasLiveSeconds >= chickEntity.becomeBigSeconds ) {
                // 变大
                chickenCacheEntity.lastLayHour = NormalGameManager._instance.mGameHours;
                chickenCacheEntity.lastLayMinute = NormalGameManager._instance.mMinute;
                chickenCacheEntity.chickenId = chickEntity.becomeBigId;
                chickEntity = getChickEntityById( chickenCacheEntity.chickenId);
            }
        }
        // 判断是否下蛋
        if( !chickEntity.becomeBigId && chickEntity.eggWeightArray ){
            let hour = NormalGameManager._instance.mGameHours - chickenCacheEntity.lastLayHour;
            let minute = NormalGameManager._instance.mMinute - chickenCacheEntity.lastLayMinute;
            let hasLiveSeconds = hour * ( 60 / gameConfig.CHICKEN_SECONDS_RATE) + Math.floor( minute / gameConfig.CHICKEN_SECONDS_RATE ) * 1;
            if ( hasLiveSeconds >= chickEntity.layingEggSeconds ) {
                // 离线收益
                let addCount = Math.floor( hasLiveSeconds / chickEntity.layingEggSeconds );
                let surplus = hasLiveSeconds % chickEntity.layingEggSeconds;
                let seconds = surplus % ( 60 / gameConfig.CHICKEN_SECONDS_RATE);
                chickenCacheEntity.lastLayHour = NormalGameManager._instance.mGameHours;
                chickenCacheEntity.lastLayMinute = seconds;
                //根据实际数量添加 鸡蛋数
                for ( let i = 0 ; i < addCount ; i ++ ) {
                    let eggId = this.getEggId( chickEntity );
                    let nestCacheData = NormalGameManager._instance.getGameData().chickenCoop.nestData.find(( item ,index ,datalist )=>{
                        return item.goodsId == eggId;
                    });
                    if ( nestCacheData.count >= 100 ){
                        break;
                    }
                    if ( !nestCacheData ) {
                        nestCacheData = { goodsId : eggId , count : 1 };
                        NormalGameManager._instance.getGameData().chickenCoop.nestData.push( nestCacheData );
                    }else{
                        nestCacheData.count++;
                    }
                }
            }
        }

    }

    //获取eggId
    getEggId( chickEntity ) : number{
        let weightAll : number = 0 ;
        for ( let eggWeight of chickEntity.eggWeightArray ) {
            weightAll += eggWeight.weight;
        }
        let randomNum = Math.floor( Math.random() * weightAll );
        let eggId : number = 0;
        for ( let eggWeight of chickEntity.eggWeightArray ) {
            if ( randomNum <= eggWeight.weight ){
                eggId = eggWeight.goodsId;
                break;
            }
            randomNum -= eggWeight.weight;
        }
        return eggId;
    }



    /**
     * 添加一只鸡 节点
     */
    addChickItemNode( chickenCacheEntity : ChickenCacheEntity ){
        let chickItemNode = cc.instantiate( this.chickenItemPrefab );
        let randomPosX = Math.floor( Math.random() * 500 ) - 250;
        let randomPosY = Math.floor( Math.random() * 500 ) - 250;
        this.activityNode.addChild( chickItemNode );
        chickItemNode.getComponent( ChickenItemPrefab ).bindData( chickenCacheEntity );
        chickItemNode.setPosition( cc.v2( randomPosX,randomPosY ) );
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getManagers().soundMgr.playMusic("hallBgm");
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 购买列表
     */
    onBtnPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let purchasePrefabNode = cc.instantiate( this.purchasePrefab );
        purchasePrefabNode.getComponent( ChickenPurchaseNode ).bindData( this );
        this.node.addChild( purchasePrefabNode );
    }

    /**
     * 打开图鉴 预制体
     */
    onBtnOpenDrawingGuide(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let drawingGuidePrefabNode = cc.instantiate( this.drawingGuidePrefab );
        this.node.addChild( drawingGuidePrefabNode );
    }

    /**
     * 打开背包
     */
    async onBtnOpenBackpack(){
        NormalGameManager._instance.mGameLayer.onBtnOpenPrefab( null , "backpack" ).then();
    }


    enlargeCapacityFlag : boolean = true;
    /**
     * 添加扩容
     */
    onBtnAddCapacity(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.openEnlargeCapacity();
    }
    @property(cc.Prefab)
    enlargeCapacityPrefab : cc.Prefab = null;
    /**
     * 打开扩容
     */
    openEnlargeCapacity(){
        if ( this.enlargeCapacityFlag == false ) {
            return;
        }
        this.enlargeCapacityFlag = false;
        let enlargeCapacityNode = cc.instantiate( this.enlargeCapacityPrefab );
        this.uiNode.addChild( enlargeCapacityNode );
        enlargeCapacityNode.getComponent( ChickenEnlargeCapacity ).bindData( this );
    }

    /**
     * 观看视频后扩容
     */
    enlargeCapacity(){
        NormalGameManager._instance.getGameData().chickenCoop.capacity += 6;
        NormalGameManager._instance.writeGameData();
    }

    /**
     * 回收金钱
     */
    recycleHoleMoney( coins : number ){
        console.log("回收加钱" , coins );
        let tempAddCoinEffect = cc.instantiate( this.blackHoleNode.getChildByName("money") );
        O1HD.getServices().userSrv.setCoins( coins , true );
        tempAddCoinEffect.active = true;
        tempAddCoinEffect.getChildByName("lbCoins").getComponent(cc.Label).string = `+${coins}`;
        this.uiNode.addChild( tempAddCoinEffect );
        tempAddCoinEffect.setPosition( this.uiNode.convertToNodeSpaceAR( tempAddCoinEffect.convertToWorldSpaceAR(cc.v2())));
        cc.tween( tempAddCoinEffect )
            .by( 0.5 ,{ y : 100 , opacity : 100 } )
            .call(()=>{
                tempAddCoinEffect.removeFromParent();
                tempAddCoinEffect.destroy();
            })
            .start();
    }
    /**
     * 检查是否丢入黑洞
     * @param pos
     * @param callback
     */
    checkHoleNode( pos : cc.Vec2 , callback ){
        if ( this.blackHoleNode.getBoundingBoxToWorld().contains( pos ) ) {
            console.log("回收 成功" );
            //卖出
            callback( true );
        }else{
            console.log("回收 失败" );
            callback( false );
        }
    }
}
